import React from 'react';
import GateScheduleService from './services/gate-schedule.service';

interface Props {
  date: string;
  shift?: string | number;
  isToday: boolean;
}

const GateScheduleTableHeaderCell: React.FC<Props> = (props) => {
  const { date, shift, isToday } = props;

  return (
    <div className={`gate-schedule-table-header-cell ${isToday ? ' today' : ''}`}>
      {isToday ? <div className="gate-schedule-table-today-label">TODAY</div> : null}
      <div>{GateScheduleService.geDayOfWeek(date)}</div>
      <div>{GateScheduleService.geMonthDay(date)}</div>
      {shift ? <div>{`SHIFT ${shift}`}</div> : null}
    </div>
  );
};
GateScheduleTableHeaderCell.displayName = 'GateSchedule.TableHeaderCell';

export default GateScheduleTableHeaderCell;
